export default {
    ONTOLOGY_RELOADED_SUCCESSFULLY: "Онтологическая модель успешно обновлена",
    CONNECTION_TESTED_SUCCESSFULLY: "Соединение проверено успешно",
    CONNECTION_SAVED_SUCCESSFULLY: "Соединение успешно сохранено",
    SETTING_SAVED_SUCCESSFULLY: "Параметр успешно сохранён"
};
